
import "./tip.less"

function createTip(type,text){
    let dom = document.createElement("div");
    dom.className = `z-tip ${type}`
    dom.innerHTML = `${text}`

    document.body.appendChild(dom);
    return dom;
}

function removeTip(dom){
    dom.classList.remove('active');
    setTimeout(()=>{
        dom.remove();
    },1000)
}

function animationTip(dom){
    setTimeout(()=>{
        dom.classList.add('active');
    })
}



const deal = async function(params){
    let {type,text,time = 1000} = params;
    let dom = createTip(type,text);
    animationTip(dom)
    setTimeout(()=>{
        removeTip(dom)
    },time)
}

export default deal